import { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';
import { ContentTreeNode, ContentTreeNodeType } from './content-tree';

export class FirstAlignArea {
    public slideIndex: number;
    public node?: ContentTreeNode; // 指的是有排列信息的第一个节点的父节点，当前节点应该取children[0]
    public area?: IRect;
    public type?: ContentTreeNodeType;
    public constructor(slideIndex: number, node?: ContentTreeNode, area?: IRect) {
        this.slideIndex = slideIndex;
        this.node = node;
        this.area = area;
        this.type = node?.parent?.type;
    }

    public hasText(): boolean {
        if (!this.node) return false;
        return this.node.hasText();
    }
}
